<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.83315 11.9296C11.7201 11.9296 13.2497 10.3783 13.2497 8.46478C13.2497 6.55123 11.7201 5 9.83315 5C7.94623 5 6.41657 6.55123 6.41657 8.46478C6.41657 10.3783 7.94623 11.9296 9.83315 11.9296ZM3 18.1782C3 15.4227 5.03954 13.1889 7.55543 13.1889H12.1109C14.6268 13.1889 16.6663 15.4227 16.6663 18.1782C16.6663 18.8671 16.1156 19.4255 15.4363 19.4255H4.22997C3.55067 19.4255 3 18.8671 3 18.1782Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.0481 6.2021C15.0481 5.76027 15.4063 5.4021 15.8481 5.4021C17.7126 5.4021 19.2241 6.91358 19.2241 8.77809C19.2241 10.6426 17.7126 12.1541 15.8481 12.1541C15.4063 12.1541 15.0481 11.7959 15.0481 11.3541C15.0481 10.9122 15.4063 10.5541 15.8481 10.5541C16.8289 10.5541 17.6241 9.75894 17.6241 8.77809C17.6241 7.79724 16.8289 7.0021 15.8481 7.0021C15.4063 7.0021 15.0481 6.64393 15.0481 6.2021ZM16.3361 13.9301C16.3361 13.4882 16.6943 13.1301 17.1361 13.1301H17.5654C19.9042 13.1301 21.8001 15.026 21.8001 17.3647V18.2234C21.8001 18.6652 21.4419 19.0234 21.0001 19.0234C20.5582 19.0234 20.2001 18.6652 20.2001 18.2234V17.3647C20.2001 15.9096 19.0205 14.7301 17.5654 14.7301H17.1361C16.6943 14.7301 16.3361 14.3719 16.3361 13.9301Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>
<style lang="scss" scoped></style>
